import { combineReducers } from "redux";
import isLoadingByRedux from "./reducerLoading";
import Login from "./reducerLogin";
import selectedComs from "./reducerSelectedComs";
import dynamicComs from "./reducerDynamicComs";
import domainInfo from "./reducerDomainInfo";
import User from "./reducerUser";
import Tran from "./reducerTran";
import alertMessage from "./reducerAlertMessage";
import userAgent from "./reducerUserAgent";
import styles from "./reducerStyles";
import merchantInfo from "./reducerMerchantInfo";
import templateByRedux from "./reducerTemplate";
import currency from "./reducerCurrency";
import notify from "./reducerNotify";



const rootReducer = combineReducers({
  tran: Tran,
  domainInfo,
  user: User,
  currency,
  login: Login,
  selectedComs: selectedComs,
  dynamicComs: dynamicComs,
  isLoadingByRedux,
  alertMessage,
  userAgent,
  styles,
  merchantInfo,
  templateByRedux,
  notify

});

export default rootReducer;
